export default {
	title: 'Indicatori',
	url: 'indicatori',
	subtitle:
		"Elenca i tuoi indicatori di successo e organizzali per categorie — di default, le 4 prospettive della Balanced Scorecard: Finanziaria, Clienti, Processi interni, Apprendimento e crescita. La scheda Visualizzazione li presenta come balanced scorecard, con la loro evoluzione per scenario.",
	no_description: 'Nessun indicatore definito',
	context_worse: 'Negativo',
	context_best: 'Positivo',
	tabs: {
		filters: {
			title: 'Filtri vista'
		},
		general: {
			title: 'Generale'
		},
		export: {
			title: 'Esporta'
		},
		comments: {
			title: 'Cronologia'
		},
		bot: {
			title: 'IA'
		}
	},
	messages: {
		edit_constraint: 'Modifica indicatore',
		create_constraint: 'Crea un nuovo indicatore'
	},
	onboarding: {
		title: 'Revisione degli indicatori',
		description:
			"Verifica che gli indicatori coprano le categorie della Balanced Scorecard e siano collegati al piano d'azione."
	}
};
